const authentication = require('../../react-azure-adb2c2').default;

export const get_bookmarks = () => {
    const url = process.env.REACT_APP_API_CRM_URL + `/v1/bookmarks/list`;
    // const url = `http://localhost:5000/v1/bookmarks/list`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'get',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-type': 'application/json; charset=UTF-8'
        }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
}

export const insert_bookmark = (values: any) => {
    // const url = `http://localhost:5000/v1/bookmarks/insert`;
    const url = process.env.REACT_APP_API_CRM_URL + `/v1/bookmarks/insert`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify({
            name: values.name,
            uri: values.uri,
        }),
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-type': 'application/json; charset=UTF-8'
        }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
}

export const delete_bookmark = (id: any) => {
    // const url = `http://localhost:5000/v1/bookmarks/delete/${id}`;
    const url = process.env.REACT_APP_API_CRM_URL + `/v1/bookmarks/delete/${id}`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'delete',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-type': 'application/json; charset=UTF-8'
        }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
}
